// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1uY-P","overflowing":"ReadFullNote_overflowing__kdFcd"};